import {
  GET_DETAIL_ACTION_ROLE_SUCCESS,
  GET_DETAIL_PERMISSION_ROLE_SUCCESS,
  GET_DETAIL_ROLE_SUCCESS,
  GET_LIST_ROLE_SUCCESS,
  PAGINATION_DEFAULT,
  SET_LOADING_ROLE,
} from '../../constants';
import { IRoleState } from '../types';

interface ActionProps {
  type: string;
  payload: any;
}

const initState: any = {
  list: {
    data: [],
    total: 0,
    limit: PAGINATION_DEFAULT.limit,
    offset: PAGINATION_DEFAULT.offset,
  },
  detail: {
    data: null,
    permissions: [],
    actions: [],
  },
  isLoadingRequest: false,
  isDeleteRequest: false,
  isUpdateRequest: false,
  isCreateRequest: false,
};

const role = (state: IRoleState = initState, action: ActionProps) => {
  const { type, payload } = action;

  switch (type) {
    case GET_LIST_ROLE_SUCCESS: {
      return {
        ...state,
        list: {
          ...state.list,
          data: payload.data,
          total: payload.total,
        },
      };
    }

    case GET_DETAIL_ROLE_SUCCESS: {
      return {
        ...state,
        detail: {
          ...state.detail,
          data: payload.data,
        },
      };
    }

    case GET_DETAIL_PERMISSION_ROLE_SUCCESS: {
      return {
        ...state,
        detail: {
          ...state.detail,
          permissions: payload.permissions,
        },
      };
    }

    case GET_DETAIL_ACTION_ROLE_SUCCESS: {
      return {
        ...state,
        detail: {
          ...state.detail,
          actions: payload.actions,
        },
      };
    }

    case SET_LOADING_ROLE: {
      return {
        ...state,
        ...payload,
      };
    }

    default: {
      return state;
    }
  }
};

export default role;
